module.exports = require('./helpers/bundle-url').getBundleURL('dj12v') + "mathWallet.346af017.svg";